// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3hgG3","header":"Messages_header__XsRJg"};